export const eventBindUnbind = "permissions-group__permissions-bind-unbind"